// Mapping between runtime SfxBed objects (with ephemeral blob: URLs) and
// the IDB record shape (raw bytes + metadata). Pure except for the URL
// creation on the restore direction. Used by useSessionPersistence.

import type { SfxBed } from '@/stores/session';
import type { StoredSfxBedEntry, StoredSfxBeds } from './indexeddb';

/** Strip the runtime-only blob URL; keep bytes + metadata + placement. */
export function sfxBedsToStored(beds: SfxBed[]): StoredSfxBeds {
  return {
    savedAt: new Date().toISOString(),
    beds: beds.map((b): StoredSfxBedEntry => ({
      id: b.id,
      name: b.name,
      duration: b.duration,
      buffer: b.buffer,
      mimeType: b.mimeType ?? 'audio/mpeg',
      ...(b.offset !== undefined ? { offset: b.offset } : {}),
      ...(b.sourceOffset !== undefined ? { sourceOffset: b.sourceOffset } : {}),
    })),
  };
}

/** Rebuild runtime beds from a stored record — mints a fresh blob: URL per
 *  entry (the persisted one from the previous process is dead). */
export function storedToSfxBeds(record: StoredSfxBeds): SfxBed[] {
  return record.beds.map((e): SfxBed => ({
    id: e.id,
    name: e.name,
    duration: e.duration,
    buffer: e.buffer,
    mimeType: e.mimeType,
    url: URL.createObjectURL(
      new Blob([e.buffer], { type: e.mimeType || 'audio/mpeg' }),
    ),
    ...(e.offset !== undefined ? { offset: e.offset } : {}),
    ...(e.sourceOffset !== undefined ? { sourceOffset: e.sourceOffset } : {}),
  }));
}
